<template>
  <div class="splashscreen">
    <div class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'splashscreen',
  mounted () {
    this.$http.get('/api/auth/me').then((response) => {
      if (!response.data.id) {
        this.$router.push({ name: 'Logowanie' });
        return;
      }

      let nextRoute = this.$route.params.nextRoute;

      if (!nextRoute || nextRoute === '/wczytywanie') {
        nextRoute = '/';
      }

      this.$http.defaults.headers['X-Csrf-Token'] = `${response.data.csrf_token}`;
      this.$store.commit('setUserID', response.data.id);
      this.$store.commit('setUserEmail', response.data.email);
      this.$store.commit('setUserType', response.data.type);
      this.$store.commit('setUserPermissions', response.data.permissions);

      if (response.data.type === 'ADVISER') {
        this.$store.commit('setUserAccountValidTo', response.data.account_valid_to);
        this.$store.commit('setUserHasValidAccount', response.data.has_valid_account);
        this.$store.commit('setUserPackage', response.data.package);
      }
      window.localStorage.setItem('last-token-refresh', +new Date());

      this.$bus.$emit('user-logged-in');

      setTimeout(() => {
        if (response.data.permissions.settlements && !response.data.package) {
          this.$router.push('/rozliczenia');
          return;
        }
        this.$router.push(nextRoute);
      }, 1000);
    }).catch(error => {
      this.$bus.$emit('user-logged-out', true);
      console.log(error);

      setTimeout(() => {
        this.$router.push({ name: 'Logowanie' });
      }, 1000);
    });
  }
}
</script>
